<template>
    <div class="mail__mail-item sm:px-4 px-2 py-3" :class="[{'child':is_child=='yes'}]">

        <!-- MAIL ROW 1 : META -->
        <div class="flex w-full">
            <div class="flex w-full justify-between items-start">
                <div class="mail__details basis-2/4">
                    <div class="flex">
                        <vs-col vs-type="flex" vs-justify="flex-start"  vs-xs="6"   vs-align="center" class="status-detemain" :class="[{'w-detemain':is_child=='yes'}]">
                            <div class="items-center" style="width:20px;text-align: center;">
                                <vx-tooltip
                                    :text="status_color_icon.text"
                                    position="bottom"
                                >
                                    <feather-icon
                                        :style="status_color_icon.color"
                                        :icon="status_color_icon.icons"
                                    ></feather-icon>
                                </vx-tooltip>
                            </div>
                        </vs-col>
                        <vs-col class="ml-2 py-0 md:py-2" >
                          <h5 class="mb-3 discepline_discipline_name  break-all md:break-normal"  >{{discepline.discipline.name}}</h5>
                          <h6 class="dicepline_type_default dicepline_type_media" v-if="discepline.main_discipline == false">{{ $t('main_discipline') }}</h6>
                          <h6 class="dicepline_type_default dicepline_type_media" v-else>{{ $t('alternative_discipline') }}</h6>
                          <!-- <span v-if="is_child == 'no'">Main</span>
                          <span v-else>alter</span> -->
                        </vs-col>
                    </div>
                </div>

                <div class="mail-item__meta flex items-center basis-1/4">
                    <div class="items-center">

                       <ul>
                         <li  v-for="(load, index) in discepline.type_load" :key="index" class="flex">
                          <div class="h-2 w-2 rounded-full mr-2 md:mt-1 lg:mt-2 bg-primary hidden md:inline "></div>
                            <span class="load_name" v-if="load.uid_1c.slice(0,3) == 'СРС'"> {{load.uid_1c }} </span>
                            <span class="load_name" v-else> {{load.name }} </span>

                         </li>
                       </ul>

                    </div>
                </div>

                <div class="mail-item__meta flex justify-end  basis-1/4">
                    <span class="discepline_credit">{{ $t('credit') }}: {{discepline.credit}}</span>
                </div>
                <div class="px-3" v-if="is_edvisor&&!status_info">
                    <div v-if="discepline.is_active">
                        <vx-tooltip  position="left"
                                     :text="$t('deactivate_discipline')">
                            <vs-button :size=icon_size @click.stop="exclude_discipline(discepline,false)"  icon="delete" color="danger" >
                            </vs-button>
                        </vx-tooltip>
                    </div>
                    <div v-else>
                        <vx-tooltip  position="left" :text="$t('restore_discipline')"  >
                            <vs-button :size=icon_size @click="exclude_discipline(discepline,true)" icon="replay"></vs-button>
                        </vx-tooltip>
                    </div>
                </div>
                <div v-else class="flex px-3">
                    <vx-tooltip
                        vs-type="flex" vs-justify="flex-start"  vs-align="center"
                        v-if="!discepline.is_active"
                        text="Дисциплина исключена"
                        position="left"
                    >
                        <feather-icon
                            style="color: red;"
                            icon="XCircleIcon"
                        ></feather-icon>
                    </vx-tooltip>

                </div>


            </div>
        </div>

    </div>
</template>

<script>
import Status from './DisList/Status.vue';
import CounterMixin from './DisList/CounterMixin.vue'
import changeStatusMixin from './DisList/changeStatusMixin.vue'
import changeIsActiveMixin from './DisList/changeIsActiveMixin.vue'
import {mapGetters} from "vuex";
export default {
    props: {
        discepline:{
            type:Object,
            required:true,
        },
        is_child:{
            type:String,
            default:'no'
        }
    },
    mixins:[
        Status,// это computed status_color_icon
        CounterMixin,
        changeStatusMixin,
        changeIsActiveMixin
    ],
    data () {
        return {
            isSelectedMail: this.isSelected
        }
    },
    watch: {

    },
    computed:{
        is_edvisor(){
            return this.$store.state.user.user.role.is_supervisor
        },
        ...mapGetters({
            disceplines:'regis_discepline/getListDiscepline',
            GET_STATUS_INFO: 'regis_discepline/GET_STATUS_INFO',
        }),
        user() {
            return this.$store.state.user.user
        },
        status_info(){
            if(this.GET_STATUS_INFO){
                let code = this.GET_STATUS_INFO.code
                return code == 'CONFIRMED'
            }else{
                return false
            }
        },
        icon_size() {
            return this.$store.state.windowWidth < 992 ? "small" : "default";
        },
    },
    methods: {
        async exclude_discipline(d,val_d){
            this.$vs.loading()
            if(val_d){
                var data_false = {'is_active': true}

            }else{
                var data_false = {'is_active': false}
            }
            await this.$http.post(`/user/exclude_put_adviser_discipline/`, data_false,{
                params:{
                    discipline:d.discipline.uid,
                    student:this.$route.query.student,
                    acad_period:this.$route.query.acad_period,
                    study_year:this.$route.query.study_year,

                }
            }).then((res)=> {
                this.changeStatusDiscipline(res.data),
                // this.discepline.is_active = val_d,
                this.changeIs_ActiveDiscipline(val_d)
                this.getMaxAndMin()

            })

            this.$vs.loading.close()
        },



    }
}

</script>


<style lang="css">
    @media only screen and (max-width: 992px) {
        .discepline_discipline_name{
            font-size: 10px;
        }
        .load_name{
            font-size: 8px;
        }
        .discepline_credit{
            font-size: 10px;
            margin-left: 5px;
        }
        .dicepline_type_media{
            line-height: 1.2;
            font-size: 8px;
            color: inherit;
            font-weight: 400;

        }

    }

    .dicepline_type_default{
        line-height: 1.2;
        color: inherit;
        font-weight: 400;

    }
.mail__mail-item.child{
    background: aliceblue;
  }
  .basis-1\/4{
      width: 25%;
  }
  .basis-2\/4{
      width: 50%;
  }

  .status-detemain{
    text-align: center;
    width:20px !important;
  }

  .status-detemain.w-detemain{
    text-align: center;
    width:30px !important;
  }
</style>
